<shared-modal-type-dynamic-height [modalData]="modalData" [center]="false" [mobilePreserve]="true" [size]="size"
    (onCloseClick)="handleCloseClick($event)" class="modal-for-adyen">

    <shared-header [center]="false" [brandAccent]="true" type="5" marginTop="md" marginBottom="none"
        class="modal-for-adyen__sub-h">
        Extra security layer
    </shared-header>
    <shared-header [center]="false" class="modal-for-adyen__h" type="2" marginTop="xs" marginBottom="lg">
        Provide your card's <br />CVV/CVC number
    </shared-header>

    <div class="modal-for-adyen__content">
        <shared-form-for-adyen-cvv (onFormSubmit)="handleOnFormSubmit()" [modal]="true" [compact]="true"
            (onInit)="handleOnFormInit($event)">
        </shared-form-for-adyen-cvv>
    </div>
</shared-modal-type-dynamic-height>
